export default function ArrowDown({ ...props }) {
  return (
    <svg width='24' height='25' viewBox='0 0 24 25' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path d='M7 10.29L12 15.29L17 10.29H7Z' fill='#4E545E' />
    </svg>
  )
}
